import React from 'react'
import {
  Navigation,
  ScrollUpButton,
  ScrollDownButton,
  MainMenu,
} from 'components/Parts'
import {
  TitleContent,
  TableContent,
  PhotoContent,
  EmptyBox,
} from 'components/Content'
import { CardMedia, Hidden } from '@material-ui/core'

import {
  HistoryArticle,
  ProfileArticle,
  ResearchArticle,
  UrlArticle,
} from 'text/article'
import SCROLL from 'constants/scrolls'
import useStyles from './style'

const App = () => {
  const classes = useStyles()
  return (
    <CardMedia className={classes.root} image="rainbow2.jpg">
      <Navigation />
      <MainMenu />
      <div className={classes.content}>
        <Hidden xsDown>
          <TitleContent />
        </Hidden>
        <TableContent name={SCROLL.PROFILE} article={ProfileArticle} />
        <TableContent name={SCROLL.RESEARCH} article={ResearchArticle} />
        <PhotoContent />
        <TableContent name={SCROLL.HISTORY} article={HistoryArticle} />
        <TableContent name={SCROLL.URL} article={UrlArticle} isLink={true} />
        <EmptyBox />
        <ScrollDownButton />
        <ScrollUpButton />
      </div>
    </CardMedia>
  )
}

export default App
